/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import ColorPickerComponent from '../../../customizeComponentLayout/colorPicker';
import SpaceComponent from '../../../customizeComponentLayout/spaceComponent';
import {
  optionPaddingleft,
  opBgColor,
  optionPaddingtop,
  optionPaddingright,
  optionPaddingbottom,
  optionMarginleft,
  optionMargintop,
  optionMarginright,
  optionMarginbottom,
} from '../../../../redux/multipleChoice/mcq.action';

interface OptionCustomizeProps {
  setChanged: Function;
}

const mapState = ({ mcqform }: any) => ({
  bgColor: mcqform.bgColor,
  opBgColor: mcqform.opBgColor,
  optionPaddingtop: mcqform.optionPaddingtop,
  optionPaddingleft: mcqform.optionPaddingleft,
  optionPaddingbottom: mcqform.optionPaddingbottom,
  optionPaddingright: mcqform.optionPaddingright,
  optionMargintop: mcqform.optionMargintop,
  optionMarginleft: mcqform.optionMarginleft,
  optionMarginbottom: mcqform.optionMarginbottom,
  optionMarginright: mcqform.optionMarginright,
});

const mapDispatch = (dispatch: Function) => ({
  OpBgColor: (form: {}) => dispatch(opBgColor(form)),
  SetOptionPaddingleft: (form: {}) => dispatch(optionPaddingleft(form)),
  SetOptionPaddingtop: (form: {}) => dispatch(optionPaddingtop(form)),
  SetOptionPaddingright: (form: {}) => dispatch(optionPaddingright(form)),
  SetOptionPaddingbottom: (form: {}) => dispatch(optionPaddingbottom(form)),
  SetOptionMarginleft: (form: {}) => dispatch(optionMarginleft(form)),
  SetOptionMargintop: (form: {}) => dispatch(optionMargintop(form)),
  SetOptionMarginright: (form: {}) => dispatch(optionMarginright(form)),
  SetOptionMarginbottom: (form: {}) => dispatch(optionMarginbottom(form)),
});

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OptionCustomizeProps;

const OptionCustomize = (props: Props) => {
  const { opBgColor, OpBgColor, setChanged } = props;
  const handleBgColorChange = (props: { opBgColor: string }) => {
    OpBgColor({ opBgColor: props.opBgColor });
    setChanged(true);
  };
  return (
    <>
      <ColorPickerComponent
        type='optionBgColor'
        title='Background'
        SetColor={handleBgColorChange}
        color={opBgColor}
        defaultColor={props.bgColor}
        setIsOptionBgChanged={props.setChanged}
      />
      <SpaceComponent
        componentType='Padding'
        left={props.optionPaddingleft}
        top={props.optionPaddingtop}
        right={props.optionPaddingright}
        bottom={props.optionPaddingbottom}
        SetLeft={props.SetOptionPaddingleft}
        SetTop={props.SetOptionPaddingtop}
        SetRight={props.SetOptionPaddingright}
        SetBottom={props.SetOptionPaddingbottom}
      />
      <SpaceComponent
        componentType='Margin'
        left={props.optionMarginleft}
        top={props.optionMargintop}
        right={props.optionMarginright}
        bottom={props.optionMarginbottom}
        SetLeft={props.SetOptionMarginleft}
        SetTop={props.SetOptionMargintop}
        SetRight={props.SetOptionMarginright}
        SetBottom={props.SetOptionMarginbottom}
      />
    </>
  );
};

export default connector(OptionCustomize);
